import { FieldFilter } from 'components/organisms/tasks/filters';
import { ApiFilter, ApiGroupFilter } from 'utils/simple-search-filter/simple-search-filter';
/**
 * Checks if a filter or any of its nested filters have valid criteria
 */ export const hasValidFilters = (filter)=>{
    var _filter_criteria_filter, _filter_criteria_filter1, _filter_criteria, _filter_nestedFilter;
    if (!filter) {
        return false;
    }
    const hasValidCriteria = (filter === null || filter === void 0 ? void 0 : (_filter_criteria = filter.criteria) === null || _filter_criteria === void 0 ? void 0 : (_filter_criteria_filter1 = _filter_criteria.filter) === null || _filter_criteria_filter1 === void 0 ? void 0 : (_filter_criteria_filter = _filter_criteria_filter1.call(_filter_criteria, (x)=>FieldFilter.isValid(x))) === null || _filter_criteria_filter === void 0 ? void 0 : _filter_criteria_filter.length) > 0;
    if (hasValidCriteria) {
        return true;
    }
    if ((_filter_nestedFilter = filter.nestedFilter) === null || _filter_nestedFilter === void 0 ? void 0 : _filter_nestedFilter.length) {
        return filter.nestedFilter.some(hasValidFilters);
    }
    return false;
};
/**
 * Checks if a grouped filter or any of its nested filters have valid criteria
 */ export const hasValidGroupFilters = (filter)=>{
    var _filter_groupCriteria, _filter_nestedFilters;
    if (!filter) {
        return false;
    }
    const hasValidCriteria = ((_filter_groupCriteria = filter.groupCriteria) === null || _filter_groupCriteria === void 0 ? void 0 : _filter_groupCriteria.filter((group)=>FieldFilter.isValid(group.criteria)).length) > 0;
    if (hasValidCriteria) {
        return true;
    }
    if ((_filter_nestedFilters = filter.nestedFilters) === null || _filter_nestedFilters === void 0 ? void 0 : _filter_nestedFilters.length) {
        return filter.nestedFilters.some(hasValidGroupFilters);
    }
    return false;
};
/**
 * Extracts all valid filters from a filter and its nested filters
 */ export const extractAllValidFilters = (filter)=>{
    var _filter_criteria;
    var _filter_nestedFilter;
    if (!filter) {
        return [];
    }
    const currentFilters = ((_filter_criteria = filter.criteria) !== null && _filter_criteria !== void 0 ? _filter_criteria : []).filter(FieldFilter.isValid);
    if ((_filter_nestedFilter = filter.nestedFilter) === null || _filter_nestedFilter === void 0 ? void 0 : _filter_nestedFilter.length) {
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        return [
            ...currentFilters,
            ...filter.nestedFilter.flatMap(extractAllValidFilters)
        ];
    }
    // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
    return currentFilters;
};
/**
 * Compares two filters hierarchically, level by level
 */ export const compareFiltersHierarchically = (filter1, filter2)=>{
    var _filter1_criteria, _filter2_criteria, _filter1_nestedFilter, _filter2_nestedFilter;
    if (!filter1 && !filter2) {
        return true;
    }
    if (!filter1 || !filter2) {
        return false;
    }
    if (filter1.type !== filter2.type) {
        return false;
    }
    const validCriteria1 = ((_filter1_criteria = filter1.criteria) !== null && _filter1_criteria !== void 0 ? _filter1_criteria : []).filter(FieldFilter.isValid);
    const validCriteria2 = ((_filter2_criteria = filter2.criteria) !== null && _filter2_criteria !== void 0 ? _filter2_criteria : []).filter(FieldFilter.isValid);
    if (validCriteria1.length !== validCriteria2.length) {
        return false;
    }
    const sortedCriteria1 = validCriteria1.sort((a, b)=>a.field.fieldName.localeCompare(b.field.fieldName));
    const sortedCriteria2 = validCriteria2.sort((a, b)=>a.field.fieldName.localeCompare(b.field.fieldName));
    if (ApiFilter.toQueryStringFormat(sortedCriteria1) !== ApiFilter.toQueryStringFormat(sortedCriteria2)) {
        return false;
    }
    const nestedFilters1 = (_filter1_nestedFilter = filter1.nestedFilter) !== null && _filter1_nestedFilter !== void 0 ? _filter1_nestedFilter : [];
    const nestedFilters2 = (_filter2_nestedFilter = filter2.nestedFilter) !== null && _filter2_nestedFilter !== void 0 ? _filter2_nestedFilter : [];
    if (nestedFilters1.length !== nestedFilters2.length) {
        return false;
    }
    const sortNestedFilters = (filters)=>{
        return filters.sort((a, b)=>{
            var _a_criteria, _b_criteria;
            const criteriaA = ((_a_criteria = a.criteria) !== null && _a_criteria !== void 0 ? _a_criteria : []).filter(FieldFilter.isValid);
            const criteriaB = ((_b_criteria = b.criteria) !== null && _b_criteria !== void 0 ? _b_criteria : []).filter(FieldFilter.isValid);
            return ApiFilter.toQueryStringFormat(criteriaA).localeCompare(ApiFilter.toQueryStringFormat(criteriaB));
        });
    };
    const sortedNested1 = sortNestedFilters(nestedFilters1.map((filter)=>({
            ...filter
        })));
    const sortedNested2 = sortNestedFilters(nestedFilters2.map((filter)=>({
            ...filter
        })));
    return sortedNested1.every((nestedFilter1, index)=>compareFiltersHierarchically(nestedFilter1, sortedNested2[index]));
};
/**
 * Compares two group filters hierarchically, level by level
 * This function is specifically designed to handle group-based filters
 */ export const compareGroupFiltersHierarchically = (filter1, filter2)=>{
    var _filter1_groupCriteria, _filter2_groupCriteria, _filter1_nestedFilters, _filter2_nestedFilters;
    if (!filter1 && !filter2) {
        return true;
    }
    if (!filter1 || !filter2) {
        return false;
    }
    if (filter1.type !== filter2.type) {
        return false;
    }
    const validCriteria1 = ((_filter1_groupCriteria = filter1.groupCriteria) !== null && _filter1_groupCriteria !== void 0 ? _filter1_groupCriteria : []).filter((filter)=>FieldFilter.isValid(filter.criteria));
    const validCriteria2 = ((_filter2_groupCriteria = filter2.groupCriteria) !== null && _filter2_groupCriteria !== void 0 ? _filter2_groupCriteria : []).filter((filter)=>FieldFilter.isValid(filter.criteria));
    if (validCriteria1.length !== validCriteria2.length) {
        return false;
    }
    const sortedCriteria1 = validCriteria1.sort((a, b)=>a.criteria.field.fieldName.localeCompare(b.criteria.field.fieldName));
    const sortedCriteria2 = validCriteria2.sort((a, b)=>a.criteria.field.fieldName.localeCompare(b.criteria.field.fieldName));
    if (// @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
    ApiGroupFilter.toQueryStringFormatForGroups(sortedCriteria1) !== // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
    ApiGroupFilter.toQueryStringFormatForGroups(sortedCriteria2)) {
        return false;
    }
    const nestedGroups1 = (_filter1_nestedFilters = filter1.nestedFilters) !== null && _filter1_nestedFilters !== void 0 ? _filter1_nestedFilters : [];
    const nestedGroups2 = (_filter2_nestedFilters = filter2.nestedFilters) !== null && _filter2_nestedFilters !== void 0 ? _filter2_nestedFilters : [];
    if (nestedGroups1.length !== nestedGroups2.length) {
        return false;
    }
    const sortNestedGroups = (groups)=>{
        return groups.sort((a, b)=>{
            var _a_groupCriteria, _b_groupCriteria;
            const criteriaA = ((_a_groupCriteria = a.groupCriteria) !== null && _a_groupCriteria !== void 0 ? _a_groupCriteria : []).filter((group)=>FieldFilter.isValid(group.criteria));
            const criteriaB = ((_b_groupCriteria = b.groupCriteria) !== null && _b_groupCriteria !== void 0 ? _b_groupCriteria : []).filter((group)=>FieldFilter.isValid(group.criteria));
            return ApiGroupFilter.toQueryStringFormatForGroups(// @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
            criteriaA).localeCompare(ApiGroupFilter.toQueryStringFormatForGroups(criteriaB));
        });
    };
    // Clone arrays before sorting to prevent mutating the original arrays
    const sortedNested1 = sortNestedGroups(nestedGroups1.map((group)=>({
            ...group
        })));
    const sortedNested2 = sortNestedGroups(nestedGroups2.map((group)=>({
            ...group
        })));
    return sortedNested1.every((nestedGroup1, index)=>compareGroupFiltersHierarchically(nestedGroup1, sortedNested2[index]));
};
